import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(user) {
  const req = axiosCommon.getAxiosParamsAuth(`/users/${user.id}`, 'put', user)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/users/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(user) {
  const req = axiosCommon.getAxiosParamsAuth('/users', 'post', user)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/users?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}

async function readProfile() {
  const req = axiosCommon.getAxiosParamsAuth('/users/profile', 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
  readProfile
}


